import { requestCatalog, requestCatalogSR } from './api';
import { REST_METHOD, REST_URL } from 'constants/index';

export type CatalogPayload = {
  catalog_item_id: string;
  requested_for: string;
  quantity: number;
  variables: Record<string, any>;
};

const CatalogServices = {
  getById: async (catalog_id: string) => {
    try {
      const requestParams = {
        url: REST_URL.GET_BY_ID,
        method: `${REST_METHOD.GET}`,
        queryParams: { catalog_id },
      };
      const response = await requestCatalog(requestParams);
      return response.data;
    } catch (error) {
      return null;
    }
  },
  getConfig: async (config_name: string) => {
    try {
      const requestParams = {
        url: REST_URL.GET_CONFIG,
        method: REST_METHOD.GET,
        queryParams: { config_name },
      };
      const response = await requestCatalog(requestParams);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  submitRequest: async (data: CatalogPayload) => {
    try {
      const requestParams = {
        url: `${REST_URL.CART}${REST_URL.CHECKOUT}`,
        method: `${REST_METHOD.POST}`,
        data: data,
      };
      const response = await requestCatalog(requestParams);
      return response.data;
    } catch (error) {
      return null;
    }
  },
  getLocation: async (params: { keyword: string }) => {
    try {
      const requestParams = {
        url: REST_URL.GET_LOCATION,
        method: `${REST_METHOD.GET}`,
        queryParams: params,
      };
      const response = await requestCatalog(requestParams);
      return response?.data;
    } catch (error) {
      throw error;
    }
  },
  getFilterCatalog: async (id: string, params: {type?: string, keyword?: string}) => {
    try {
      const requestParams = {
        url: `${REST_URL.CATALOGS}/${id}${REST_URL.FILTERS}`,
        method: `${REST_METHOD.GET}`,
        queryParams: params
      }
      const response = await requestCatalogSR(requestParams);
      return response?.data;
    }
    catch(error) {
      throw error;
    }
  },
  getListSRSetting: async (params: {type?: string, keyword?: string, category_ids?: string, catalog_ids?: string, page_size: number, page_index: number}) => {
    try {
      const requestParams = {
        url: `${REST_URL.SETTINGS}`,
        method: `${REST_METHOD.GET}`,
        queryParams: params
      }
      const response = await requestCatalogSR(requestParams);
      return response?.data;
    }
    catch(error) {
      throw error;
    }
  },
  getDetailSRSetting: async (id: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.CATALOGS}${REST_URL.SETTINGS}${id}`,
        method: `${REST_METHOD.GET}`,
      }
      const response = await requestCatalogSR(requestParams);
      return response;
    }
    catch(error) {
      throw error;
    }
  },
  getListCatalog: async (params?: { active?: boolean }) => {
    try {
      const requestParams = {
        url: `${REST_URL.CATALOGS}`,
        method: `${REST_METHOD.GET}`,
        queryParams: params,
      }
      const response = await requestCatalogSR(requestParams);
      return response;
    }
    catch(error) {
      throw error;
    }
  },
  getUserGroups: async ( fields?: string, query?: string ) => {
    try {
      const requestParams = {
        url: `${REST_URL.GET_TABLE_DATA_GENERIC}${REST_URL.SYS_USER_GROUP}`,
        method: `${REST_METHOD.GET}`,
        queryParams: {
          sysparm_fields: fields,
          sysparm_query: query,
        },
      }
      const response = await requestCatalog(requestParams);
      return response;
    }
    catch(error) {
      throw error;
    }
  },
};

export default CatalogServices;
